import { render, staticRenderFns } from "./HistoryTiket.vue?vue&type=template&id=7344e061&scoped=true&"
import script from "./HistoryTiket.vue?vue&type=script&lang=js&"
export * from "./HistoryTiket.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTiket.scss?vue&type=style&index=0&id=7344e061&lang=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7344e061",
  null
  
)

export default component.exports